"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tick = void 0;
const retrommo_types_1 = require("retrommo-types");
const WorldCharacter_1 = require("./classes/WorldCharacter");
const getConstants_1 = require("./functions/getConstants");
const pixel_pigeon_1 = require("pixel-pigeon");
const definables_1 = require("definables");
const getPianoKeyAudioPath_1 = require("./functions/getPianoKeyAudioPath");
const handleWorldCharacterClick_1 = require("./functions/handleWorldCharacterClick");
const volumeChannels_1 = require("./volumeChannels");
const state_1 = require("./state");
const tick = () => {
    const constants = (0, getConstants_1.getConstants)();
    if (state_1.state.values.worldState !== null) {
        let clickedWorldCharacter = null;
        for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
            if (worldCharacter.wasClicked &&
                (clickedWorldCharacter === null ||
                    worldCharacter.order > clickedWorldCharacter.order)) {
                clickedWorldCharacter = worldCharacter;
            }
            worldCharacter.wasClicked = false;
            if (worldCharacter.hasEmote() &&
                worldCharacter.emote.usedAt <
                    (0, pixel_pigeon_1.getCurrentTime)() - constants["emote-duration"]) {
                (0, pixel_pigeon_1.removeEntity)(worldCharacter.emote.entityID);
                worldCharacter.emote = null;
            }
            let percentMoved;
            if (worldCharacter.hasMovedAt()) {
                percentMoved = Math.min(1, ((0, pixel_pigeon_1.getCurrentTime)() - worldCharacter.movedAt) /
                    constants["movement-duration"]);
            }
            else {
                percentMoved = 1;
            }
            const pixelsMoved = Math.round(percentMoved * constants["tile-size"]);
            switch (worldCharacter.direction) {
                case retrommo_types_1.Direction.Down: {
                    const x = worldCharacter.position.x * constants["tile-size"];
                    const y = worldCharacter.position.y * constants["tile-size"] -
                        (constants["tile-size"] - pixelsMoved);
                    (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.entityID, {
                        x,
                        y,
                    });
                    if (worldCharacter.hasEmote()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.emote.entityID, {
                            x,
                            y: y - constants["tile-size"],
                        });
                    }
                    if (worldCharacter.hasMarkerEntity()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.markerEntityID, {
                            x,
                            y,
                        });
                    }
                    break;
                }
                case retrommo_types_1.Direction.Left: {
                    const x = worldCharacter.position.x * constants["tile-size"] +
                        (constants["tile-size"] - pixelsMoved);
                    const y = worldCharacter.position.y * constants["tile-size"];
                    (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.entityID, {
                        x,
                        y,
                    });
                    if (worldCharacter.hasEmote()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.emote.entityID, {
                            x,
                            y: y - constants["tile-size"],
                        });
                    }
                    if (worldCharacter.hasMarkerEntity()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.markerEntityID, {
                            x,
                            y,
                        });
                    }
                    break;
                }
                case retrommo_types_1.Direction.Right: {
                    const x = worldCharacter.position.x * constants["tile-size"] -
                        (constants["tile-size"] - pixelsMoved);
                    const y = worldCharacter.position.y * constants["tile-size"];
                    (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.entityID, {
                        x,
                        y,
                    });
                    if (worldCharacter.hasEmote()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.emote.entityID, {
                            x,
                            y: y - constants["tile-size"],
                        });
                    }
                    if (worldCharacter.hasMarkerEntity()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.markerEntityID, {
                            x,
                            y,
                        });
                    }
                    break;
                }
                case retrommo_types_1.Direction.Up: {
                    const x = worldCharacter.position.x * constants["tile-size"];
                    const y = worldCharacter.position.y * constants["tile-size"] +
                        (constants["tile-size"] - pixelsMoved);
                    (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.entityID, {
                        x,
                        y,
                    });
                    if (worldCharacter.hasEmote()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.emote.entityID, {
                            x,
                            y: y - constants["tile-size"],
                        });
                    }
                    if (worldCharacter.hasMarkerEntity()) {
                        (0, pixel_pigeon_1.setEntityPosition)(worldCharacter.markerEntityID, {
                            x,
                            y,
                        });
                    }
                    break;
                }
            }
        }
        if (clickedWorldCharacter !== null) {
            (0, handleWorldCharacterClick_1.handleWorldCharacterClick)(clickedWorldCharacter.id);
        }
        const updatedPianoNotes = [];
        for (const pianoNote of state_1.state.values.worldState.values.pianoNotes) {
            if (pianoNote.playAt <= (0, pixel_pigeon_1.getCurrentTime)()) {
                (0, pixel_pigeon_1.playAudioSource)((0, getPianoKeyAudioPath_1.getPianoKeyAudioPath)(pianoNote.index, pianoNote.type), {
                    volumeChannelID: volumeChannels_1.sfxVolumeChannelID,
                });
            }
            else {
                updatedPianoNotes.push(pianoNote);
            }
        }
        state_1.state.values.worldState.setValues({
            pianoNotes: updatedPianoNotes,
        });
    }
};
exports.tick = tick;
